import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { isWidthDown } from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import FilterSearch from "./FilterSearch";
import FilterSort from "./FilterSort";
import FilterCategories from "./FilterCategories";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { _t } from "js/utils/TranslationService";

export const FilterPanel = ({
  isLogged,
  classes,
  cleanFilters,
  width,
  searchCriteria
}) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(
    () => {
      if (searchCriteria) {
        setExpanded(false);
      }
    },
    [searchCriteria]
  );

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  const headerFilters = (
    <Grid item container className={classes.filterHeader}>
      <Typography variant="h6" gutterBottom>
        {_t("Filtros")}
      </Typography>
      <Button
        onClick={cleanFilters}
        className={classes.cleanFiltersBtn}
        classes={{ textPrimary: classes.textPrimary }}
        size="small"
        color="primary"
        variant="text"
      >
        {_t("Limpiar filtros")}
      </Button>
    </Grid>
  );
  const filtros = (
    <Grid item container className={classes.filtersContainer}>
      {!isWidthDown("sm", width) && headerFilters}
      <Grid item container>
        <FilterSearch />
      </Grid>
      <Grid item container>
        <FilterSort />
      </Grid>
      <Grid item container>
        <FilterCategories isLogged={isLogged} />
      </Grid>
    </Grid>
  );
  return isWidthDown("sm", width) ? (
    <div className={classes.root}>
      <ExpansionPanel expanded={expanded} onChange={handleChange}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          {headerFilters}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>{filtros}</ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  ) : (
    <div>{filtros}</div>
  );
};

export default FilterPanel;
